import React, { Component } from "react";
import { Helmet } from "react-helmet";
import logo from "../../assets/logo.png";
import Navbar from "../Navbar/Navbar";
import PoliciesCodesCard from "./PoliciesCodesCard";
import BottomBar from "../BottomBar/BottomBar";
class PoliciesCodes extends Component {
  render() {
    return (
   
        <section id='policiesandcodes' className="main">
          <Helmet>
            <title>Policies &amp; Codes | MoneyMonk</title>
            <meta name="description" content="View all policies and codes of MoneyMonk including fair practice code, grievance policy, privacy policy, and schedule of charges." />
            <link rel="canonical" href="https://moneymonkapp.in/policiesandcodes" />
          </Helmet>
          <Navbar imageData={logo} />
          <PoliciesCodesCard />
          <BottomBar />
        </section>

    );
  }
}

export default PoliciesCodes;
